import { MouseEvent } from 'react';
import { Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { AddButtonProps } from './types';

const AddButton = ({
  title,
  readOnly,
  onReadOnly,
  onClick,
  className,
}: AddButtonProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.VALIDATIONS);
  const handleSubmit = (e: MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    return readOnly ? onReadOnly() : onClick();
  };
  return (
    <Buttons.Tiny
      iconStart="IconAddRoundedS"
      mode="default"
      onClick={handleSubmit}
      label={t(title)}
      data-testid="addButton"
      className={className}
    />
  );
};
AddButton.defaultProps = {
  className: null,
  title: '',
  readonly: false,
};

export default AddButton;
